import React, { FunctionComponent } from 'react';
import {
  Fade,
  Table,
  TableBody,
  TableContainer,
  Typography,
} from '@mui/material';
import _ from 'lodash';

import { ILessonHistory } from '../../../../../../../../../../store/V2/LessonHistorySlice';
import useTable, {
  defaultRowsPerPageOptions,
  TUseTableState,
} from '../../../../../../../../../../components/V2/Table/type1/useTable';
import TableHeadCustom, {
  THeadLabelItem,
} from '../../../../../../../../../../components/V2/Table/type1/TableHeadCustom';
import LessonHistoryLogTableRow from './LessonHistoryLogTableRow';
import TableNoData from '../../../../../../../../../../components/V2/Empty/TableNoData';

interface HistoryTabProps {
  lessonHistory: ILessonHistory;
}

const defaultOrderBy = 'createdAt';
const defaultOrder = 'desc';
const defaultTableData: TUseTableState = {
  defaultOrderBy,
  defaultOrder,
  defaultDense: false,
  defaultCurrentPage: 0,
  defaultRowsPerPage: defaultRowsPerPageOptions[0],
  defaultSelected: [],
};

const tableHeaderLabels: THeadLabelItem[] = [
  {
    id: 'createdAt',
    label: 'Date',
    sortable: false,
    minWidth: 100,
    maxWidth: 100,
  },
  {
    id: 'createdBy',
    label: 'User',
    sortable: false,
    minWidth: 100,
    maxWidth: 100,
  },
  {
    id: 'title',
    label: 'Task',
    sortable: false,
  },
];

const HistoryTab: FunctionComponent<HistoryTabProps> = ({ lessonHistory }) => {
  // State
  const tableData = useTable(defaultTableData);

  const logList = _.orderBy(lessonHistory.logs, ['createdAt'], ['desc']);

  const handleSort = (id: string) => {
    tableData.onSort(id);
  };

  return (
    <Fade in>
      <div>
        <div style={{ marginBottom: '16px' }}>
          <Typography fontWeight={600} fontSize="16px">
            History (Logs)
          </Typography>
        </div>
        <div>
          <TableContainer sx={{ position: 'relative', maxHeight: '400px' }}>
            <Table stickyHeader size="medium">
              <TableHeadCustom
                order={tableData.order}
                orderBy={tableData.orderBy}
                rowCount={0}
                headLabels={tableHeaderLabels}
                numSelected={tableData.selected.length}
                onSort={handleSort}
              />
              <TableBody>
                {logList.map((log) => (
                  <LessonHistoryLogTableRow key={log._id} log={log} />
                ))}
                {!logList.length ? (
                  <TableNoData title="No history found" />
                ) : null}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </Fade>
  );
};

export default HistoryTab;
